import jQuery from "jquery";
import gsap from 'gsap';

jQuery(document).ready(function ($) {
    let tl1;
    let isTweenPaused = true;
    let init = function () {


        let $animationContainer = $('.ex_home_page_animation');
        let $sc = $('.scene-container');
        let sceneWidth = $sc.width();
        let sceneHeight = $sc.height();



        let triggerOffset = document.documentElement.clientHeight * 0.75;
        let sceneDuration = 3.8;
        let sContentAnimationDuration = sceneDuration * 2;
        let sTitleAnimationDuration = sceneDuration / 4;


        let contentWrapperHeight = $sc.find('.s1-cw').height();

        $sc.find('.map-eu').height($sc.find('img').height());
        $sc.find('.map-pl').height($sc.find('img').height());
        $sc.find('.map-world').height($sc.find('img').height());

        let titleStartVars = {y: 0, x: 50, scale: 1, alpha: 0};
        let titleAnimationVars = {duration: sTitleAnimationDuration, y: 0, x: 0, scale: 1, alpha: 1, ease: "power1.out"};
        let titleEndVars = {duration: sTitleAnimationDuration, y: 0, x: -50, scale: 1, alpha: 0, ease: "power1.in"};

        let subTitleStartVars = {y: 0, x: 50, scale: 1, alpha: 0};
        let subTitleAnimationVars = {duration: sTitleAnimationDuration, y: 0, x: 0, scale: 1, alpha: 1, ease: "power1.out"};
        let subTitleEndVars = {duration: sTitleAnimationDuration, y: 0, x: -50, scale: 1, alpha: 0, ease: "power1.in"};

        let mapStartVars = {y: 0, x: 0, scale: 1.15, alpha: 0};
        let mapAnimationVars = {duration: sceneDuration, y: 0, x: 0, scale: 1, alpha: 1, ease: "none"};
        let mapEndVars = {duration: sceneDuration, y: 0, x: 0, scale: 0.85, alpha: 0, ease: "none"};

        let sContentAlphaAnimation = 0.7;
        let sContentContainerStartVars = {y: 0, x: 30, scale: 1, alpha: 0};
        let sContentContainerAnimationVars = {duration: sContentAnimationDuration, y: 0, x: 0, scale: 1, ease: "power1.out"};
        let sContentContainerEndVars = {duration: sContentAnimationDuration, y: 0, x: -30, scale: 1, ease: "none"};

        let sNumberStartVars = {y: 0, x: -30, scale: 1, alpha: 0};
        let sNumberAnimationVars = {duration: sContentAnimationDuration, y: 0, x: 0, scale: 1, ease: "power1.out"};
        let sNumberEndVars = {duration: sContentAnimationDuration, y: 0, x: 30, scale: 1, ease: "none"};

        tl1 = gsap.timeline({repeat: -1, paused: true })
            .set($sc.find('.map-world'), mapStartVars)
            .set($sc.find('.s1-title h2'), titleStartVars)
            .set($sc.find('.s1-title .desc'), subTitleStartVars)
            .set($sc.find('.s1-content-container .number'), sNumberStartVars)
            .set($sc.find('.s1-content-container .desc'), sContentContainerStartVars)

            .set($sc.find('.map-eu'), mapStartVars)
            .set($sc.find('.s2-title h2'), titleStartVars)
            .set($sc.find('.s2-title .desc'), titleStartVars)
            .set($sc.find('.s2-content-container .number'), sNumberStartVars)
            .set($sc.find('.s2-content-container .desc'), sContentContainerStartVars)

            .set($sc.find('.map-pl'), mapStartVars)
            .set($sc.find('.s3-title h2'), titleStartVars)
            .set($sc.find('.s3-title .desc'), titleStartVars)
            .set($sc.find('.s3-content-container .number'), sNumberStartVars)
            .set($sc.find('.s3-content-container .desc'), sContentContainerStartVars)

            //WORLD
            .add("worldStart")
            .to($sc.find('.map-world'), mapAnimationVars, 0)
            .add("worldVisible")
            .to($sc.find('.map-world'), mapEndVars, ">")
            .add("worldHidden")

            .to($sc.find('.s1-title h2'), titleAnimationVars, "worldStart+=0.2")
            .to($sc.find('.s1-title .desc'), subTitleAnimationVars, "worldStart+=0.3")

            .to($sc.find('.s1-content-container .number'), sNumberEndVars, "worldStart")
            .to($sc.find('.s1-content-container .desc'), sContentContainerEndVars, "worldStart")

            .to($sc.find('.s1-content-container .number'), {duration: sContentAlphaAnimation, alpha: 1}, "worldStart+=0.3")
            .to($sc.find('.s1-content-container .desc'), {duration: sContentAlphaAnimation, alpha: 1}, "worldStart+=0.3")
            .to($sc.find('.s1-content-container .number'), {duration: sContentAlphaAnimation, alpha: 0}, "worldHidden-=0.9")
            .to($sc.find('.s1-content-container .desc'), {duration: sContentAlphaAnimation, alpha: 0}, "worldHidden-=0.9")

            .to($sc.find('.s1-title h2'), titleEndVars, "worldHidden-=0.8")
            .to($sc.find('.s1-title .desc'), subTitleEndVars, "worldHidden-=0.7")


            //EU
            .add("euStart")
            .to($sc.find('.map-eu'), mapAnimationVars, "worldHidden")
            .add("euVisible")
            .to($sc.find('.map-eu'), mapEndVars, ">")
            .add("euHidden")

            .to($sc.find('.s2-title h2'), titleAnimationVars, "euStart+=0.2")
            .to($sc.find('.s2-title .desc'), subTitleAnimationVars, "euStart+=0.3")

            .to($sc.find('.s2-content-container .number'), sNumberEndVars, "euStart")
            .to($sc.find('.s2-content-container .desc'), sContentContainerEndVars, "euStart")

            .to($sc.find('.s2-content-container .number'), {duration: sContentAlphaAnimation, alpha: 1}, "euStart+=0.3")
            .to($sc.find('.s2-content-container .desc'), {duration: sContentAlphaAnimation, alpha: 1}, "euStart+=0.3")
            .to($sc.find('.s2-content-container .number'), {duration: sContentAlphaAnimation, alpha: 0}, "euHidden-=0.9")
            .to($sc.find('.s2-content-container .desc'), {duration: sContentAlphaAnimation, alpha: 0}, "euHidden-=0.9")

            .to($sc.find('.s2-title h2'), titleEndVars, "euHidden-=0.8")
            .to($sc.find('.s2-title .desc'), subTitleEndVars, "euHidden-=0.7")


            //PL
            .add("plStart")
            .to($sc.find('.map-pl'), mapAnimationVars, "euHidden")
            .add("plVisible")
            .to($sc.find('.map-pl'), mapEndVars, ">")
            .add("plHidden")

            .to($sc.find('.s3-title h2'), titleAnimationVars, "plStart+=0.2")
            .to($sc.find('.s3-title .desc'), subTitleAnimationVars, "plStart+=0.3")

            .to($sc.find('.s3-content-container .number'), sNumberEndVars, "plStart")
            .to($sc.find('.s3-content-container .desc'), sContentContainerEndVars, "plStart")

            .to($sc.find('.s3-content-container .number'), {duration: sContentAlphaAnimation, alpha: 1}, "plStart+=0.3")
            .to($sc.find('.s3-content-container .desc'), {duration: sContentAlphaAnimation, alpha: 1}, "plStart+=0.3")
            .to($sc.find('.s3-content-container .number'), {duration: sContentAlphaAnimation, alpha: 0}, "plHidden-=0.9")
            .to($sc.find('.s3-content-container .desc'), {duration: sContentAlphaAnimation, alpha: 0}, "plHidden-=0.9")

            .to($sc.find('.s3-title h2'), titleEndVars, "plHidden-=0.8")
            .to($sc.find('.s3-title .desc'), subTitleEndVars, "plHidden-=0.7")

    }
    let checkIsInViewPort = function(el) {
       let $el = el;
        let elementTop = $el.offset().top;
        let elementBottom = elementTop + $el.outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        if(elementBottom > viewportTop && elementTop < viewportBottom) {
            if(isTweenPaused) {
                tl1.play();
                isTweenPaused = false;
            }
        }
        else {
            if(isTweenPaused === false) {
               tl1.pause();
               isTweenPaused = true;
            }
        }
    }
    if ($('.ex_home_page_animation').length > 0) {
        init();

        checkIsInViewPort($('.ex_home_page_animation'));
        $(window).on('resize scroll', function() {
            checkIsInViewPort($('.ex_home_page_animation'));
        });
    }
});